<template>
  <div class="config-manage">
    <common-bg-plate>
      <div class="section-list">
        <!-- 同步链上数据时间 -->
        <detail-section v-if="showSyncInterval" title="同步链上数据时间">
          <el-input
            v-model.number="chainTimeCont"
            placeholder="请输入内容"
            class="chain-time-input"
          >
            <el-select slot="append" v-model="chainTimeUnit" placeholder="请选择">
              <el-option label="秒" value="second"></el-option>
              <el-option label="分" value="minute"></el-option>
              <el-option label="时" value="hour"></el-option>
            </el-select>
          </el-input>
        </detail-section>
        <el-divider></el-divider>
        <!-- BASE64 解码上链数据 -->
        <detail-section title="BASE64 解码上链数据">
          <el-switch v-model="isDecode"></el-switch>
        </detail-section>
        <el-divider></el-divider>
        <!-- 切换背景 -->
        <detail-section title="切换背景">
          <div class="select-background-color">
            <div class="select-btn-section">
              <div class="select-btn dark-color" @click="selectBackgroundFn('darkTheme')">
                <div v-if="themeName == 'darkTheme'" class="select-btn-tip"></div>
              </div>
              <div class="select-btn-title">深色</div>
            </div>
            <div class="select-btn-section">
              <div class="select-btn light-color" @click="selectBackgroundFn('defaultTheme')">
                <div v-if="themeName == 'defaultTheme'" class="select-btn-tip"></div>
              </div>
              <div class="select-btn-title">浅色</div>
            </div>
          </div>
        </detail-section>
        <el-divider></el-divider>
        <!-- 修改license -->
        <detail-section title="修改license" class="modify-license">
          <div class="time">当前过期时间：{{ untilTime || $constants.EMPTY }}</div>
          <el-input
            v-model="licenseContent"
            class="license-input"
            :rows="3"
            type="textarea"
            placeholder="请输入新的license"
          ></el-input>
          <el-button class="delete-license-btn" type="text" @click="deleteLicenseFn">
            <span :class="['iconfont', 'icon-clear', 'btn-icon']"></span>删除license
          </el-button>
        </detail-section>
        <el-divider></el-divider>
      </div>
      <div class="button-list">
        <el-button
          type="primary"
          :disabled="saveLoading"
          @click="saveConfigFn"
        >保存</el-button>
      </div>
    </common-bg-plate>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'Configmanage',

  data() {
    return {
      chainTimeCont: 0,
      chainTimeUnit: 'second',
      isDecode: true,
      themeName: 'darkTheme',
      showSyncInterval: false,
      loading: true,
      licenseContent: '',
      untilTime: '',
      saveLoading: false
    }
  },
  watch: {
    '$store.state.app.themeName': {
      deep: true,
      handler() {
        this.getPersonConfigFn()
      }
    }
  },

  mounted() {
    this.getSyncIntervalFn()
    this.getPersonConfigFn()
    if (
      this.$store.state.app.userInfo.roleName == '平台管理员' ||
      this.$store.state.app.userInfo.roleName == '管理员'
    ) {
      this.showSyncInterval = true
    }
  },
  methods: {
    ...mapActions([]),
    selectBackgroundFn(type) {
      type == 'darkTheme' ? (this.themeName = 'darkTheme') : (this.themeName = 'defaultTheme')
      // localStorage.setItem('cbaas_system_theme', this.themeName)
      // this.$store.dispatch('updateTheme', this.themeName)
      // document.body.className = this.themeName
      this.setPersonConfigFn(true)
    },
    // 获取个性化设置内容
    getPersonConfigFn() {
      this.untilTime = localStorage.getItem('cbaas_system_valid_time')
      this.$apis.configmanage
        .getPersonConfig()
        .then(res => {
          this.isDecode = res.data.txValueDecode
          res.data.backGround == 'darkTheme'
            ? (this.themeName = 'darkTheme')
            : (this.themeName = 'defaultTheme')
          localStorage.setItem('cbaas_system_theme', this.themeName)
          this.$store.dispatch('updateTheme', this.themeName)
          document.body.className = this.themeName
          localStorage.setItem('cbaas_system_isDecode', this.isDecode)
          this.$store.dispatch('updateDecode', this.isDecode)

          this.loading = false
        })
        .catch(err => {
          this.loading = false
        })
    },
    // 设置个性化设置内容
    setPersonConfigFn(silence = false) {
      this.$apis.configmanage
        .setPersonConfig({
          backGround: this.themeName,
          txValueDecode: this.isDecode
        })
        .then(res => {
          localStorage.setItem('cbaas_system_theme', this.themeName)
          this.$store.dispatch('updateTheme', this.themeName)
          document.body.className = this.themeName
          silence || this.$message.success('保存成功')
          this.saveLoading = false
        })
        .catch(err => {
          this.saveLoading = false
        })
    },
    // 获取链同步时间间隔
    getSyncIntervalFn() {
      this.$apis.configmanage.getSyncInterval().then(res => {
        if (res.data.hour) {
          this.chainTimeUnit = 'hour'
          this.chainTimeCont = res.data.hour
        } else if (res.data.minute) {
          this.chainTimeUnit = 'minute'
          this.chainTimeCont = res.data.minute
        } else {
          this.chainTimeUnit = 'second'
          this.chainTimeCont = res.data.second
        }
      })
    },
    // 设置链同步时间间隔
    setSyncIntervalFn() {
      this.chainTimeCont = Number(this.chainTimeCont)
      let params = {}
      if (this.chainTimeUnit == 'hour') {
        params.hour = this.chainTimeCont
      } else if (this.chainTimeUnit == 'minute') {
        params.minute = this.chainTimeCont
      } else {
        params.second = this.chainTimeCont
      }
      this.$apis.configmanage.setSyncInterval(params).then(res => {
        this.saveLoading = false
      }).catch(err => {
        this.saveLoading = false
      })
    },
    // 校验时间输入内容
    checkTime() {
      let reg = /^[1-9]\d*|0$/
      this.chainTimeCont = Number(this.chainTimeCont)
      if (this.chainTimeUnit == 'hour') {
        let con1 = !reg.test(this.chainTimeCont)
        let con2 = reg.test(this.chainTimeCont) && this.chainTimeCont > 23
        if (con1 || con2) {
          this.$message.warning('请输入正确的时间！')
          return false
        } else {
          return true
        }
      } else {
        let con1 = !reg.test(this.chainTimeCont)
        let con2 = reg.test(this.chainTimeCont) && this.chainTimeCont > 59
        if (con1 || con2) {
          this.$message.warning('请输入正确的时间！')
          return false
        } else {
          return true
        }
      }
    },
    // 修改license
    updateLicenseFn() {
      if (this.licenseContent) {
        this.$apis.app
          .updateLicense({
            content: this.licenseContent
          })
          .then(res => {
            console.log(res)
            this.$message.success('修改license成功')
          })
          .catch(err => {
            this.$message.error('修改license失败')
          })
      }
    },
    // 删除license
    deleteLicenseFn() {
      this.$confirm('此操作将删除license, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$apis.app
          .deleteLicense()
          .then(res => {
            this.$message.success('删除license成功')
          })
          .catch(err => {
            this.$message.error('删除license失败')
          })
      })
    },

    // 保存配置
    saveConfigFn() {
      let res = this.checkTime()
      if (res) {
        this.saveLoading = true
        this.setPersonConfigFn()
        this.updateLicenseFn()
        if (this.showSyncInterval) {
          this.setSyncIntervalFn()
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'config-manage',
  (
    --config-manage-color: #ffffff,
    --config-manage-select-btn-dark-background-color: #000e2c,
    --config-manage-select-btn-dark-border-color: #000e2c,
    --config-manage-select-btn-light-background-color: #ffffff,
    --config-manage-select-btn-light-border-color: #ffffff
  ),
  (
    --config-manage-color: #192227,
    --config-manage-select-btn-dark-background-color: #000e2c,
    --config-manage-select-btn-dark-border-color: #000e2c,
    --config-manage-select-btn-light-background-color: #ffffff,
    --config-manage-select-btn-light-border-color: #ebebeb
  )
);
.config-manage {
  @include adaptation(
    (
      --config-manage-divider-offset: 32px,
      --config-manage-divider-margin: 0 16px 8px,
      --config-manage-chain-time-input-width: 298px,
      --config-manage-chain-time-input-inner-height: 32px,
      --config-manage-chain-time-select-width: 72px,
      --config-manage-select-btn-width: 141px,
      --config-manage-select-btn-height: 76px,
      --config-manage-select-btn-margin-right: 16px,
      --config-manage-select-btn-border-radius: 2px,
      --config-manage-select-btn-tip-width: 32px,
      --config-manage-select-btn-tip-height: 14px,
      --config-manage-select-btn-title-line-height: 17px,
      --config-manage-select-btn-title-font-size: 12px,
      --config-manage-select-btn-title-margin-top: 12px,
      --config-manage-select-btn-border-width: 1px,
      --config-manage-modify-license-input-width: 298px,
      --config-manage-modify-license-input-margin-top: 12px,
      --config-manage-modify-license-btn-margin-left: 12px,
      --config-manage-button-list-margin: 20px 16px 20px 43px,
      --config-manage-section-content-padding-left: 27px
    )
  );
  --config-manage-min-height: var(--base-main-router-body-avaliable-height);
  --config-manage-divider-width: calc(100% - var(--config-manage-divider-offset));
  --config-manage-select-btn-tip-top: calc(0px - var(--config-manage-select-btn-border-width));
  --config-manage-select-btn-tip-right: calc(0px - var(--config-manage-select-btn-border-width));
  color: var(--config-manage-color);

  .common-bg-plate {
    min-height: var(--config-manage-min-height);
    .el-divider {
      width: var(--config-manage-divider-width);
      margin: var(--config-manage-divider-margin);
    }

    .cbaas-detail-section {
      /deep/ .content {
        padding-left: var(--config-manage-section-content-padding-left);
      }
    }

    .chain-time-input {
      width: var(--config-manage-chain-time-input-width);

      /deep/ {
        .el-input__inner {
          height: var(--config-manage-chain-time-input-inner-height);
        }

        .el-input-group__append .el-input__inner:focus {
          border-color: transparent;
        }
      }

      .el-select {
        width: var(--config-manage-chain-time-select-width);
      }
    }

    .select-background-color {
      display: flex;
      justify-content: flex-start;

      .select-btn-section {
        .select-btn {
          display: inline-block;
          width: var(--config-manage-select-btn-width);
          height: var(--config-manage-select-btn-height);
          margin-right: var(--config-manage-select-btn-margin-right);
          border-radius: var(--config-manage-select-btn-border-radius);
          text-align: center;
          position: relative;

          &:hover {
            cursor: pointer;
            transition: all 300ms;
          }

          .select-btn-tip {
            background-image: url('~@/assets/images/config/select-mark.png');
            background-size: 100% 100%;
            width: var(--config-manage-select-btn-tip-width);
            height: var(--config-manage-select-btn-tip-height);
            top: var(--config-manage-select-btn-tip-top);
            right: var(--config-manage-select-btn-tip-right);
            position: absolute;
          }
        }

        .select-btn-title {
          line-height: var(--config-manage-select-btn-title-line-height);
          font-size: var(--config-manage-select-btn-title-font-size);
          margin-top: var(--config-manage-select-btn-title-margin-top);
        }

        .dark-color {
          background: var(--config-manage-select-btn-dark-background-color);
          border: var(--config-manage-select-btn-border-width) solid
            var(--config-manage-select-btn-dark-border-color);
        }

        .light-color {
          background: var(--config-manage-select-btn-light-background-color);
          border: var(--config-manage-select-btn-border-width) solid
            var(--config-manage-select-btn-light-border-color);
        }
      }
    }

    .modify-license {
      .license-input {
        width: var(--config-manage-modify-license-input-width);
        margin-top: var(--config-manage-modify-license-input-margin-top);
      }

      .delete-license-btn {
        margin-left: var(--config-manage-modify-license-btn-margin-left);

        .btn-icon {
          margin-right: var(--base-size-4);
        }
      }
    }

    .button-list {
      margin: var(--config-manage-button-list-margin);
    }
  }
}
</style>
